import { BaseResponse } from './base-response.model';
import {
	CustomReportFieldJSON,
	CustomReportField,
} from './custom-report-field.model';
import { StringUtility } from '../utility/string.utility';
import { CustomReportOperatorJSON } from './custom-report-operator.model';

export interface CustomReportTablesResponse extends BaseResponse {
	message: string;
	tables: CustomReportTableJSON[];
	stringOperators: CustomReportOperatorJSON[];
	dateOperators: CustomReportOperatorJSON[];
}

export interface CustomReportTableJSON {
	name: string;
	alias: string;
	fields: CustomReportFieldJSON[];
}

export class CustomReportTable {
	constructor(
		public name: string,
		public alias: string,
		public fields: CustomReportField[]
	) {}

	static fromJSON(json: CustomReportTableJSON): CustomReportTable {
		return Object.assign(Object.create(CustomReportTable.prototype), json, {
			fields: json.fields
				? json.fields.map((field) => CustomReportField.fromJSON(field))
				: [],
		});
	}

	static convertFieldListToNameArray(
		fieldList: string,
		tableName: string,
		tables: CustomReportTable[]
	): string[] {
		const matchingTable = this.findTableByName(tableName, tables);
		if (!matchingTable) {
			return null;
		}
		return StringUtility.trimmedCommaSeparatedValues(fieldList);
	}

	static convertFieldListToAliasArray(
		fieldList: string,
		tableName: string,
		tables: CustomReportTable[]
	): string[] {
		if (fieldList == null) {
			return null;
		}
		const matchingTable = this.findTableByName(tableName, tables);
		if (!matchingTable) {
			return null;
		}
		const fieldNames: string[] = this.convertFieldListToNameArray(
			fieldList,
			tableName,
			tables
		);
		return fieldNames.map((fieldName) =>
			CustomReportField.convertFieldNameToAlias(
				fieldName,
				matchingTable.fields
			)
		);
	}

	static convertFieldListToAliasString(
		fieldList: string,
		tableName: string,
		tables: CustomReportTable[]
	): string {
		const aliasArray = this.convertFieldListToAliasArray(
			fieldList,
			tableName,
			tables
		);
		return aliasArray ? aliasArray.join(', ') : null;
	}

	static findTableByName(
		name: string,
		tables: CustomReportTable[]
	): CustomReportTable {
		return tables.find((table) => table.name === name);
	}

	static getFieldsForTable(
		name: string,
		tables: CustomReportTable[]
	): CustomReportField[] {
		return name ? this.findTableByName(name, tables).fields : [];
	}
}
